var React = require('react');

function Cu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-32 0h682.7v512H-32z"}))),React.createElement("g",{"fillRule":"evenodd","clipPath":"url(#a)","transform":"translate(30) scale(.94)","key":1},[React.createElement("path",{"fill":"#0050f0","d":"M-32 0h768v512H-32z","key":0}),React.createElement("path",{"fill":"#fff","d":"M-32 102.4h768v102.4H-32zm0 204.8h768v102.4H-32z","key":1}),React.createElement("path",{"fill":"#ed0000","d":"M-32 0l440.7 255.7L-32 511V0z","key":2}),React.createElement("path",{"fill":"#fff","d":"M161.8 325.5L114.3 290l-47.2 35.8 17.6-58.1-47.2-36 58.3-.4 18.1-58 18.5 57.8 58.3.1-46.9 36.3 18 58z","key":3})])]);
}

Cu.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Cu;

Cu.default = Cu;
